import PageHeader from "../components/UI/PageHeader";

const FAQPage = () => {
  return (
    <>
      <PageHeader title="FAQ" />
      <div className="w-full flex justify-center">
      <div className="w-[97%] max-w-[760px] sm:bg-white sm:border sm:border-gray-100 flex flex-col space-y-6 p-4 sm:p-7 md:p-8 my-8 rounded-2xl text-[15px] leading-relaxed text-gray-600">
        <span className="text-[22px] font-bold text-gray-900">
          Frequently Asked Questions
        </span>
        <div className="flex flex-col space-y-2">
          <span className="text-[15px] font-semibold text-gray-900">What is iChereta?</span>
          <span>
            iChereta is an online platform that aggregates and delivers tender
            notices from various sources across Ethiopia. We provide a
            one-stop-shop for businesses and individuals seeking to explore
            opportunities in the Ethiopian market.
          </span>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-[15px] font-semibold text-gray-900">
            What are the sources of tenders?
          </span>
          <span>
            We source information from a variety of authenticated sources such
            as newspapers, magazines, and the websites of relevant
            organizations.
          </span>
        </div>

        <div className="flex flex-col space-y-2">
          <span className="text-[15px] font-semibold text-gray-900">
            What payment options are available?
          </span>
          <span>
            We offer two payment options for our subscription packages: bank
            transfer and Telebirr. You can pay through the following banks: -
            Commercial Bank of Ethiopia (CBE) If you have any other questions or
            concerns, please don't hesitate to reach out to us.
          </span>
        </div>

        <div className="flex flex-col space-y-2">
          <span className="text-[15px] font-semibold text-gray-900">
            How often is the tender database updated?
          </span>
          <span>
            We collect data from various sources and upload it daily. Our team
            ensures accuracy of the data.
          </span>
        </div>
      </div>
      </div>
    </>
  );
};

export default FAQPage;
